import { moment } from '@hotjar/webapp/lib/moment';
import { epochDateTime } from '@hotjar/webapp/lib/time';

var module = angular.module('hjApp');

/**
 * Implementation moved to lib/time
 */
module.filter('epochDateTime', [() => epochDateTime]);

/**
 * Format epoch timestamps as a ISO 8601 date.
 * YYYY-MM-DD
 */
module.filter('epochDate', [
    function () {
        return function (epochTime, dateFormat) {
            dateFormat = dateFormat || 'YYYY-MM-DD';
            if (typeof epochTime === 'undefined') {
                return ':';
            } else {
                return moment(epochTime * 1000).format(dateFormat);
            }
        };
    }
]);

/**
 * Format a number of milliseconds as minutes:seconds.
 *
 * The seconds will be left padded with a 0 to ensure there's always two digits.
 */
module.filter('minutesAndSeconds', [
    function () {
        return function (totalMilliseconds) {
            if (typeof totalMilliseconds === 'undefined') {
                return ':';
            } else {
                return moment.duration(totalMilliseconds).format('m:ss', { trim: false });
            }
        };
    }
]);

/**
 * Format epoch timestamps as a string, returning just the date.
 * Example: 1st January 2014
 *
 * @param altFormat Set to true to return "January 1, 2019" instead of "1st January 2014".
 */
module.filter('stringDate', [
    function () {
        return function (epochTime, altFormat) {
            var formatString = altFormat ? 'MMMM D, YYYY' : 'Do MMMM YYYY';

            if (typeof epochTime === 'undefined') {
                return '-';
            } else {
                return moment(epochTime * 1000).format(formatString);
            }
        };
    }
]);

/**
 * Get a Month's name from an epoch date.
 * e.g. 1564531200 => 'July'
 *
 * @param epochTime The epoch time to convert.
 * @param short Set to true to return "Jan" instead of "January".
 */
module.filter('monthNameFromEpoch', [
    function () {
        return function (epochTime, short) {
            var formatString = short ? 'MMM' : 'MMMM';

            if (typeof epochTime === 'undefined') {
                return '-';
            } else {
                return moment(epochTime * 1000).format(formatString);
            }
        };
    }
]);

/**
 * Get the month and year from an epoch date.
 * e.g. 1564531200 => '07 / 2019'
 *
 * @param epochTime The epoch time to convert.
 */
module.filter('monthAndYear', [
    function () {
        return function (epochTime) {
            if (typeof epochTime === 'undefined') {
                return '-';
            } else {
                return moment(epochTime * 1000).format('MM / YYYY');
            }
        };
    }
]);

/**
 * Return how much time difference in days there is between a date and now().
 *
 * @param epochTime The epoch time to base calculation on.
 * @param limitToZero Limit the lowest returnable value to 0.
 */
module.filter('daysFromNow', [
    function () {
        return function (epochTime, limitToZero) {
            var difference = moment(epochTime * 1000).diff(moment(), 'days', true);

            return limitToZero && difference < 0 ? 0 : difference;
        };
    }
]);

/**
 * Return how much time difference in days there is between a now() and date.
 *
 * @param epochTime The epoch time to subtract now() from.
 */
module.filter('daysAgo', [
    function () {
        return function (epochTime) {
            return moment().diff(moment(epochTime * 1000), 'days', true);
        };
    }
]);
